export const PageHeading = ({ eyebrow, title, description, action, testId }) => (
  <div className="fade-up flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600">{eyebrow}</p>
      <h2 className="mt-1 font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-testid={testId}>{title}</h2>
      {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
    </div>
    {action}
  </div>
);
